import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from 'app/services/models/brand.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-brand-dialog',
  templateUrl: './create-brand-dialog.component.html',
  styleUrls: ['./create-brand-dialog.component.scss']
})
export class CreateBrandDialogComponent implements OnInit {
  brandModelForm: FormGroup;

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private brandService: BrandService,
    private toastSerivce: ToastrService) { }

  ngOnInit(): void {
    this.brandModelForm = this.fb.group({
      brandName: [null, Validators.required],
    });
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.brandModelForm.valid) {
      console.log(this.brandModelForm.value);
      const response = await this.brandService.createBrand(this.brandModelForm.value.brandName);
      if (response.status) {
        this.toastSerivce.success(response.message);
        this.activeModal.close(true);
      } else {
        this.toastSerivce.error(response.message);
      }
    }
  }
}
